// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BauruRouteImport } from './routes/bauru'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ConsultaOnlineRouteImport } from './routes/consulta-online'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as LinksRouteImport } from './routes/links'
import { Route as LpRouteImport } from './routes/lp'
import { Route as MedicoDoEsporteEmBauruRouteImport } from './routes/medico-do-esporte-em-bauru'
import { Route as MedicoParaEmagrecerEmBauruRouteImport } from './routes/medico-para-emagrecer-em-bauru'
import { Route as NutrologoEmBauruRouteImport } from './routes/nutrologo-em-bauru'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as SaudeComPropositoRouteImport } from './routes/saude-com-proposito'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAvaliacoesRouteImport } from './routes/admin.avaliacoes'
import { Route as AdminCategoriasRouteImport } from './routes/admin.categorias'
import { Route as AdminConfiguracoesRouteImport } from './routes/admin.configuracoes'
import { Route as AdminContatosRouteImport } from './routes/admin.contatos'
import { Route as AdminMidiaRouteImport } from './routes/admin.midia'
import { Route as AdminRedirecionamentosRouteImport } from './routes/admin.redirecionamentos'
import { Route as AdminSeoRouteImport } from './routes/admin.seo'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as TratamentosIndexRouteImport } from './routes/tratamentos/index'
import { Route as TratamentosAvaliacao360RouteImport } from './routes/tratamentos/avaliacao-360'
import { Route as TratamentosEmagrecimentoRouteImport } from './routes/tratamentos/emagrecimento'
import { Route as TratamentosEsteticaRegenerativaRouteImport } from './routes/tratamentos/estetica-regenerativa'
import { Route as TratamentosLongevidadeRouteImport } from './routes/tratamentos/longevidade'
import { Route as TratamentosMassaMuscularRouteImport } from './routes/tratamentos/massa-muscular'
import { Route as TratamentosMedicinaDoEsporteRouteImport } from './routes/tratamentos/medicina-do-esporte'
import { Route as TratamentosSaudeHormonalRouteImport } from './routes/tratamentos/saude-hormonal'
import { Route as AdminArtigosIdRouteImport } from './routes/admin.artigos.$id'
import { Route as AdminArtigosNovoRouteImport } from './routes/admin.artigos.novo'
import { Route as BlogCategoriaIndexRouteImport } from './routes/blog.$categoria.index'
import { Route as BlogPaginaNRouteImport } from './routes/blog.pagina.$n'
import { Route as BlogCategoriaPaginaNRouteImport } from './routes/blog.$categoria.pagina.$n'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const BauruRoute = BauruRouteImport.update({
            id: '/bauru',path: '/bauru',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ConsultaOnlineRoute = ConsultaOnlineRouteImport.update({
            id: '/consulta-online',path: '/consulta-online',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const LpRoute = LpRouteImport.update({
            id: '/lp',path: '/lp',getParentRoute: () => rootRouteImport
          })
const MedicoDoEsporteEmBauruRoute = MedicoDoEsporteEmBauruRouteImport.update({
            id: '/medico-do-esporte-em-bauru',path: '/medico-do-esporte-em-bauru',getParentRoute: () => rootRouteImport
          })
const MedicoParaEmagrecerEmBauruRoute = MedicoParaEmagrecerEmBauruRouteImport.update({
            id: '/medico-para-emagrecer-em-bauru',path: '/medico-para-emagrecer-em-bauru',getParentRoute: () => rootRouteImport
          })
const NutrologoEmBauruRoute = NutrologoEmBauruRouteImport.update({
            id: '/nutrologo-em-bauru',path: '/nutrologo-em-bauru',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const SaudeComPropositoRoute = SaudeComPropositoRouteImport.update({
            id: '/saude-com-proposito',path: '/saude-com-proposito',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const VideosRoute = VideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAvaliacoesRoute = AdminAvaliacoesRouteImport.update({
            id: '/avaliacoes',path: '/avaliacoes',getParentRoute: () => AdminRoute
          })
const AdminCategoriasRoute = AdminCategoriasRouteImport.update({
            id: '/categorias',path: '/categorias',getParentRoute: () => AdminRoute
          })
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
            id: '/configuracoes',path: '/configuracoes',getParentRoute: () => AdminRoute
          })
const AdminContatosRoute = AdminContatosRouteImport.update({
            id: '/contatos',path: '/contatos',getParentRoute: () => AdminRoute
          })
const AdminMidiaRoute = AdminMidiaRouteImport.update({
            id: '/midia',path: '/midia',getParentRoute: () => AdminRoute
          })
const AdminRedirecionamentosRoute = AdminRedirecionamentosRouteImport.update({
            id: '/redirecionamentos',path: '/redirecionamentos',getParentRoute: () => AdminRoute
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const TratamentosIndexRoute = TratamentosIndexRouteImport.update({
            id: '/tratamentos/',path: '/tratamentos/',getParentRoute: () => rootRouteImport
          })
const TratamentosAvaliacao360Route = TratamentosAvaliacao360RouteImport.update({
            id: '/tratamentos/avaliacao-360',path: '/tratamentos/avaliacao-360',getParentRoute: () => rootRouteImport
          })
const TratamentosEmagrecimentoRoute = TratamentosEmagrecimentoRouteImport.update({
            id: '/tratamentos/emagrecimento',path: '/tratamentos/emagrecimento',getParentRoute: () => rootRouteImport
          })
const TratamentosEsteticaRegenerativaRoute = TratamentosEsteticaRegenerativaRouteImport.update({
            id: '/tratamentos/estetica-regenerativa',path: '/tratamentos/estetica-regenerativa',getParentRoute: () => rootRouteImport
          })
const TratamentosLongevidadeRoute = TratamentosLongevidadeRouteImport.update({
            id: '/tratamentos/longevidade',path: '/tratamentos/longevidade',getParentRoute: () => rootRouteImport
          })
const TratamentosMassaMuscularRoute = TratamentosMassaMuscularRouteImport.update({
            id: '/tratamentos/massa-muscular',path: '/tratamentos/massa-muscular',getParentRoute: () => rootRouteImport
          })
const TratamentosMedicinaDoEsporteRoute = TratamentosMedicinaDoEsporteRouteImport.update({
            id: '/tratamentos/medicina-do-esporte',path: '/tratamentos/medicina-do-esporte',getParentRoute: () => rootRouteImport
          })
const TratamentosSaudeHormonalRoute = TratamentosSaudeHormonalRouteImport.update({
            id: '/tratamentos/saude-hormonal',path: '/tratamentos/saude-hormonal',getParentRoute: () => rootRouteImport
          })
const AdminArtigosIdRoute = AdminArtigosIdRouteImport.update({
            id: '/artigos/$id',path: '/artigos/$id',getParentRoute: () => AdminRoute
          })
const AdminArtigosNovoRoute = AdminArtigosNovoRouteImport.update({
            id: '/artigos/novo',path: '/artigos/novo',getParentRoute: () => AdminRoute
          })
const BlogCategoriaIndexRoute = BlogCategoriaIndexRouteImport.update({
            id: '/$categoria/',path: '/$categoria/',getParentRoute: () => BlogRoute
          })
const BlogPaginaNRoute = BlogPaginaNRouteImport.update({
            id: '/pagina/$n',path: '/pagina/$n',getParentRoute: () => BlogRoute
          })
const BlogCategoriaPaginaNRoute = BlogCategoriaPaginaNRouteImport.update({
            id: '/$categoria/pagina/$n',path: '/$categoria/pagina/$n',getParentRoute: () => BlogRoute
          })





const AdminRouteChildren = {
  AdminAvaliacoesRoute: AdminAvaliacoesRoute,AdminCategoriasRoute: AdminCategoriasRoute,AdminConfiguracoesRoute: AdminConfiguracoesRoute,AdminContatosRoute: AdminContatosRoute,AdminMidiaRoute: AdminMidiaRoute,AdminRedirecionamentosRoute: AdminRedirecionamentosRoute,AdminSeoRoute: AdminSeoRoute,AdminIndexRoute: AdminIndexRoute,AdminArtigosIdRoute: AdminArtigosIdRoute,AdminArtigosNovoRoute: AdminArtigosNovoRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogRouteChildren = {
  BlogIndexRoute: BlogIndexRoute,BlogPaginaNRoute: BlogPaginaNRoute,BlogCategoriaIndexRoute: BlogCategoriaIndexRoute,BlogCategoriaPaginaNRoute: BlogCategoriaPaginaNRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,BauruRoute: BauruRoute,BlogRoute: BlogRouteWithChildren,ConsultaOnlineRoute: ConsultaOnlineRoute,ContatoRoute: ContatoRoute,LinksRoute: LinksRoute,LpRoute: LpRoute,MedicoDoEsporteEmBauruRoute: MedicoDoEsporteEmBauruRoute,MedicoParaEmagrecerEmBauruRoute: MedicoParaEmagrecerEmBauruRoute,NutrologoEmBauruRoute: NutrologoEmBauruRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,SaudeComPropositoRoute: SaudeComPropositoRoute,SobreRoute: SobreRoute,VideosRoute: VideosRoute,AdminLoginRoute: AdminLoginRoute,TratamentosAvaliacao360Route: TratamentosAvaliacao360Route,TratamentosEmagrecimentoRoute: TratamentosEmagrecimentoRoute,TratamentosEsteticaRegenerativaRoute: TratamentosEsteticaRegenerativaRoute,TratamentosLongevidadeRoute: TratamentosLongevidadeRoute,TratamentosMassaMuscularRoute: TratamentosMassaMuscularRoute,TratamentosMedicinaDoEsporteRoute: TratamentosMedicinaDoEsporteRoute,TratamentosSaudeHormonalRoute: TratamentosSaudeHormonalRoute,TratamentosIndexRoute: TratamentosIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)